export const flixResourceDomain = [
  "flixcar.com",
  "flixfacts.com",
  "flix360.com",
];

export const flixScriptAttributes: Record<string, string> = {
  "data-flix-button": "",
  "data-flix-button-image": "",
  "data-flix-distributor": "22",
  "data-flix-ean": "",
  "data-flix-fallback-language": "",
  "data-flix-inpage": "flix-react-inpage",
  "data-flix-language": "en",
  "data-flix-price": "",
  "data-flix-sku": "",
};

const removeFlixMediaResources = () => {
  document.querySelectorAll("script, link").forEach((element) => {
    const isFlixMediaResource = flixResourceDomain.some((flixDomain) =>
      (
        element.getAttribute(element.tagName === "SCRIPT" ? "src" : "href") ||
        ""
      ).includes(flixDomain),
    );

    if (isFlixMediaResource) {
      element.remove();
    }
  });
};

export const cleanUp = () => {
  removeFlixMediaResources();

  const hotspotDiv = document.getElementById("flix_hotspots");
  if (hotspotDiv !== null) {
    hotspotDiv.remove();
  }

  const flixInPageElement = document.getElementById("flix-react-inpage");

  if (flixInPageElement !== null) {
    flixInPageElement.replaceChildren();
  }
};

export const attachScript = (
  flixMediaContainer: HTMLDivElement,
  flixMpn: string,
  flixBrand: string,
) => {
  const flixScript = document.createElement("script");
  flixScript.src = "//media.flixfacts.com/js/loader.js";
  flixScript.async = true;

  Object.keys(flixScriptAttributes).forEach((attribute) => {
    // @ts-ignore
    flixScript.setAttribute(attribute, flixScriptAttributes[attribute]);
  });

  flixScript.setAttribute("data-flix-brand", flixBrand);
  flixScript.setAttribute("data-flix-mpn", flixMpn);

  flixMediaContainer.appendChild(flixScript);
};
